/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card, CircularProgress, Icon, MenuItem } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useLocation, useNavigate } from "react-router-dom";
import { updateAdmin } from "api";

function AdminProfile() {
  const navigate = useNavigate();

  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));

  const { sales, tasks } = reportsLineChartData;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [selectedCode, setSelectedCode] = useState("+91");
  const [mobile, setMobile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const countryCodes = [
    { code: "+91", label: "🇮🇳" },
    { code: "+1", label: "🇺🇸" },
    { code: "+44", label: "🇬🇧" },
    { code: "+61", label: "🇦🇺" },
    // Add more as needed
  ];

  useEffect(() => {
    setFirstName(user?.firstName);
    setLastName(user?.lastName);
    setEmail(user?.email);
    setMobile(user?.phone);
    // setSelectedCode(user?.code);
  }, []);

  const handleContinue = () => {
    if (firstName && lastName && email) {
      setIsSubmitted(false);

      updateAdminApi();
    } else {
      setIsSubmitted(true);
    }
  };

  const handleCancel = () => {
    navigate("/fair");
  };

  const updateAdminApi = () => {
    var params = {
      firstName: firstName,
      lastName: lastName,
      phone: mobile,
    };
    updateAdmin({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            const { user } = responseJson.data;

            localStorage.setItem("user", JSON.stringify(user));

            navigate("/fair", {});
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const ProfileDetails = () => {
    return (
      <MDBox
        p={3}
        component="form"
        role="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleContinue(); // same as your onClick
        }}
      >
        <MDTypography variant="h5" fontWeight="bold" mb={2}>
          Personal Details
        </MDTypography>

        {/* Form Fields */}
        <MDBox display="flex" gap={2} mb={3}>
          <MDInput
            label={
              <>
                First Name
                <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            helperText={isSubmitted && !firstName ? "First Name is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
          <MDInput
            label={
              <>
                Last Name
                <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            helperText={isSubmitted && !lastName ? "Last Name is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>

        <MDBox display="flex" gap={2} mb={1}>
          <MDInput
            disabled
            label={
              <>
                Email
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
            helperText={isSubmitted && !email ? "Email is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>

        <MDBox mb={2} display="flex" gap={2}>
          <MDInput
            disabled
            select
            label="Code"
            value={selectedCode}
            onChange={(e) => setSelectedCode(e.target.value)}
            sx={{ minWidth: 80 }}
            InputProps={{ sx: { height: "44px" } }}
          >
            {countryCodes.map((country) => (
              <MenuItem key={country.code} value={country.code}>
                {country.label} {country.code}
              </MenuItem>
            ))}
          </MDInput>
          <MDInput
            type="mobile"
            label="Mobile Number"
            fullWidth
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
        </MDBox>
        <MDBox display="flex" gap={2} mb={2} mt={4}>
          <MDButton color="secondary" fullWidth onClick={handleCancel}>
            Cancel
          </MDButton>
          <MDButton
            type="submit"
            variant="gradient"
            color="info"
            fullWidth
            // onClick={handleContinue}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} style={{ color: "white" }} /> : "Save"}
          </MDButton>
        </MDBox>
      </MDBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Card
        sx={{
          width: {
            xs: "100%", // for mobile devices
            sm: "80%", // small tablets
            md: "60%", // medium screens
            lg: "50%", // large screens
          },
          mx: "left", // center the card horizontally
        }}
      >
        {ProfileDetails()}
      </Card>

      <MDBox mb={2} />
      <Footer />
    </DashboardLayout>
  );
}

export default AdminProfile;
